import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field, change, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { connect } from 'react-redux';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { GRL_URL } from '../../../../../utils/pnd/PndConstants';

const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-group">
        <div className="form__form-group">
            <input
                {...input}
                  className="custom-placeholder"
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

const HubPickUpPointsAddOrUpdate = ({ handleSubmit, setMapData, setLatitude, setLongitide, address,dispatch }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddress, setAddress] = useState(null);
    const [apaIframeUrl] = useState(GRL_URL);
    const apaFrameRef = useRef(null);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleFindLocation = () => {
        toggleModal(); // Open the modal
        handleMessageToIframe(); // Send message to iframe
    };

    const handleMessageToIframe = () => {
        const datajson = '{"RequestID": ' + Math.floor((Math.random() * 20) + 1) + ',"MessageType":1,"AddressElements": [{"AddressElementTypeCode": 1,"Value":""},{"AddressElementTypeCode":2,"Value": ""},{ "AddressElementTypeCode": 3,"Value": ""},{"AddressElementTypeCode":4,"Value": ""},{"AddressElementTypeCode": 5,"Value":"520950"},{"AddressElementTypeCode": 6,"Value":"" },{"AddressElementTypeCode": 7, "Value": "" },{"AddressElementTypeCode": 8,"Value":""}]}';
        if (apaFrameRef.current) {
            apaFrameRef.current.contentWindow.postMessage(datajson, '*');
            window.addEventListener('message', handleMessageFromIframe);
        } else {
            console.error('iframe element not found');
        }
    };

    let deliveryAddress = "";
    const handleMessageFromIframe = (event) => {
        if (event && event?.data) {
            try {
                const jsonRegex = /^\s*(\{.*\}|\[.*\])\s*$/;
                if (jsonRegex.test(event?.data)) {
                    const data_from_apa = JSON.parse(event.data);
                    const buildingName = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 6);
                    const landmark = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 4);
                    const street = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 3);
                    const area = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 2);
                    const zone = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 7);
                    const city = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 8);
                    const emirates = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 1);
                    const latitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 10);
                    const longitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 9);
                    const grl = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 5);
                    // if (buildingName) {
                    //     deliveryAddress = deliveryAddress + buildingName.Value + ",";
                    // }
                    // if (landmark && !buildingName === landmark) {
                    //     deliveryAddress = deliveryAddress + landmark.Value + ",";
                    // }
                    if (buildingName && buildingName?.Value!=="") {
                        deliveryAddress = deliveryAddress + buildingName.Value + ",";
                    }
                    if(buildingName?.Value==="" && landmark?.Value!==""){
                      deliveryAddress = deliveryAddress + landmark.Value + ",";
                    }
                    if (street) {
                        deliveryAddress = deliveryAddress + street.Value + ",";
                    }
                    if (area) {
                        deliveryAddress = deliveryAddress + area.Value + ",";
                    }
                    if (zone) {
                        deliveryAddress = deliveryAddress + zone.Value + ",";
                    }
                    if (city) {
                        deliveryAddress = deliveryAddress + city.Value + ",";
                    }
                    if (emirates) {
                        deliveryAddress = deliveryAddress + emirates.Value;
                    }
                    if (deliveryAddress && deliveryAddress.includes(",,")) {
                        setAddress(deliveryAddress.replace(/,,/g, ','));
                        setMapData(deliveryAddress.replace(/,,/g, ','));
                    }
                    if (latitude) {
                        setLatitude(latitude.Value);
                    }
                    if (longitude) {
                        setLongitide(longitude.Value);
                    }
                    if(grl){
                        dispatch(change('PickUpPointsAddOrUpdateForm', 'pickUpPointGrl', grl?.Value));
                    }
                    toggleModal();
                }
            } catch (error) {
                console.error('event.data is not a valid JSON string');
            }
        }
    };
    return (
        <form className="form-animated" onSubmit={handleSubmit}>
            <Col lg={12} md={12}>

                <Row>
                    <Col lg={6} md={6}>

                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span><span className="form__form-animated-group-label">Pick Up Location Name</span>
                            <div className="form__form-group-field">
                                <Field name="pickUpPointName" component={renderField} type="text" placeholder="Location Name" validate={[required]} />

                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>

                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Pick Up Point Code</span>
                            <div className="form__form-group-field">
                                <Field name="pickupPointCode" component={renderField} type="text" placeholder="Pick Up Point Code" validate={[required]} />
                            </div>
                        </div>
                    </Col>

                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">Pick Up Point Contact Name</span>
                            <div className="form__form-group-field">
                                <Field name="pickUpPointContactName" component={renderField} type="text" placeholder="Pick Up Point Contact Name" />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Pick Up Point Mobile No.</span>
                            <div className="form__form-group-field">
                                <Field name="pickupPointContactMobileNo" component={renderField} type="text" placeholder="Pick Up Point Mobile No." validate={[required]} />
                            </div>
                        </div>
                    </Col>

                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">Pick Up Point Telephone No.</span>
                            <div className="form__form-group-field">
                                <Field name="pickUpPointPhoneNo" component={renderField} type="text" placeholder="Pick Up Point Telephone No."  />
                            </div>
                        </div>
                    </Col>

                </Row>
                <Row>
                    <Col md={12} lg={12}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Pick Up Point Address
                            </span>
                            <div className="form__form-animated-group-field">
                                <input
                                    validate={required}
                                    component="textarea"
                                    name="pickUpPointAddress"
                                    type="text"
                                    label="Pick Up Point Address"
                                    placeholder="Pick Up Point Address"
                                    value={isAddress || address}
                                />
                                <AddLocationAltIcon color="success" fontSize="large" style={{ cursor: 'pointer' }} onClick={handleFindLocation} />
                            </div>
                        </div>
                    </Col>
                    </Row>
                    <Row>
                    <Col md={4} lg={4}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Pick Up Point GRL
                            </span>
                            <div className="form__form-animated-group-field">
                                <Field
                                    // validate={required}
                                    component={renderField}
                                    name="pickUpPointGrl"
                                    type="text"
                                    disabled={true}

                                />

                            </div>
                        </div>
                    </Col>
                </Row>

            </Col>

            <div className="form__OnboardingButton">
                <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                </ButtonToolbar>
            </div>
            <Modal isOpen={isModalOpen} toggle={toggleModal} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggleModal}><b>Find Location</b></ModalHeader>
                <ModalBody>
                    <iframe ref={apaFrameRef} src={apaIframeUrl} width="100%" height="400px" title="Get Address" onLoad={handleMessageToIframe} style={{ width: '100%', height: '650px' }}></iframe>
                </ModalBody>
            </Modal>
        </form>

    );
};


HubPickUpPointsAddOrUpdate.propTypes = {
    HubPickUpPointsAddOrUpdate: PropTypes.func.isRequired,
};


const mapStateToProps = (state, data) => {
    if (data && data?.dataInfo) {
        return {
            initialValues: {
                pickUpPointId:data?.dataInfo?.pickUpPointId,
                pickUpPointAddress: data?.dataInfo?.pickUpPointAddress,
                pickupPointContactMobileNo: data.dataInfo?.pickupPointContactMobileNo,
                pickUpPointPhoneNo: data.dataInfo?.pickUpPointPhoneNo,
                longitude: data.dataInfo.longitude,
                latitude: data.dataInfo.latitude,
                pickUpPointName:data.dataInfo.pickUpPointName,
                pickUpPointContactName:data.dataInfo.pickUpPointContactName,
                pickUpPointPointId: data.dataInfo.pickUpPointPointId,
                pickupPointCode:data.dataInfo.pickupPointCode,
                pickUpPointGrl:data.dataInfo.pickUpPointGrl,
            //   /  emirate:collectionPointCode
            }
        }

    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'HubPickUpPointsAddOrUpdateForm', enableReinitialize: true })(HubPickUpPointsAddOrUpdate))